import Button from "../Button";
import { StepItem, StepItemPorps } from "./StepItem";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useEffect, useState } from "react";
import { ResData } from "../../store/backend";

export type StepProps = {
  title?: string;
  steps: StepItemPorps["step"][];
  onDeleteStep?(index: number): void;
  onOpenSaveProgram?(): void;
  onSaveStep?(): void;
  onSelectStepIndex?(stepIndex: number): void;
  selectStepIndex: number;
  style?: React.CSSProperties;
  onSwapStep?(currentStep: number, targetStep: number): void;
  state: StepItemPorps["state"];
  onEdit?(): void;
  onRunAgain?(): void;
  resData: ResData
};

export const Step = (props: StepProps) => {
  const [isDragEnabled, setDragEnabled] = useState(true);

const systemVersion = props.resData.loadSettingAck?.systemVersion

  useEffect(() => {
    switch (props.state) {
      case "FINISHED":
      case "LOGGING":
      case "LOGGED":
      case "EDITING":
      case "ACTIVE":
        {
          setDragEnabled(false);
        }
        break;
      case "DRAFT":
        {
          setDragEnabled(true);
        }
        break;
    }
  }, [props.state]);


  useEffect(() => {
    switch (props.state) {
      case "FINISHED":
      case "LOGGING":
      case "LOGGED":
      case "EDITING":
      case "ACTIVE":
        {
          setDragEnabled(false);
        }
        break;
      case "DRAFT":
        {
          setDragEnabled(true);
        }
        break;
    }

    if (props.state === 'ACTIVE') {
      const stepIndex = props.steps.findIndex(data => data.day === -1 || data.currentTime !== data.totalTime)
      props.onSelectStepIndex && props.onSelectStepIndex(stepIndex)
    }

  }, [props.steps]);


  /**
   * 无限 下标
   */
  const infIndex = props.steps.findIndex(item => item.day === -1)

  /**
   * 是否零时长
   */
  const isZeroTimeStep = props.steps.some(step => step.day === 0 && step.hour === 0 && step.minutes === 0)

  return (
    <div
      className="flex bg-quickStartLeftContentBgColor"
      style={{
        height: 649,
        width: 357,
        flexDirection: "column",
        borderRadius: 20,
        ...(props.style || {}),
      }}
    >
      <div
        style={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          paddingLeft: 16,
          paddingRight: 16,
        }}
        className="font-bold text-2xl bg-quickStartLeftHeaderBgColor text-center"
      >
        <span
          className="inline-block align-middle leading-loose text-white"
          title={props.title}
          style={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {props.title}
        </span>
      </div>

      <div
        className="flex"
        style={{
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          flex: 1,
        }}
      >
        <DragDropContext
          onDragEnd={(result) => {
            if (!result.destination) {
              return;
            }


            // 如果 source 或者 destination 是 Step 4，则不进行移动

            const isStepInvolved =
              result.source.index === infIndex || result.destination.index === infIndex;

            if (isStepInvolved) {
              return;
            }

            props.onSwapStep &&
              props.onSwapStep(
                result.source.index + 1,
                result.destination.index + 1
              );
          }}
        >
          <Droppable droppableId="droppable" isDropDisabled={!isDragEnabled}>
            {(provided, snapshot) => (
              <div
                className="flex"
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "start",
                  flex: 1,
                }}
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {props.steps?.map((item, index) => (
                  <Draggable
                    key={`${index}`}
                    draggableId={`${index}`}
                    index={index}
                    isDragDisabled={index === infIndex || !isDragEnabled} // 禁用 Step 4 拖动
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                          marginTop: 20,
                        }}
                        onClick={() => {
                          if (props.state === 'ACTIVE') return
                          props.onSelectStepIndex && props.onSelectStepIndex(index);

                        }}
                      >
                        <StepItem
                        systemVersion={systemVersion}
                          unit={props.resData.loadSettingAck?.temperatureUnit as any}
                          isDelete={props.steps.length > 1}
                          state={props.state}
                          style={
                            {
                              // background: snapshot.isDragging ? 'blue' : '',
                            }
                          }
                          step={item}
                          select={props.selectStepIndex === index}
                          number={index + 1}
                          onDelete={(e) =>
                            props.onDeleteStep && props.onDeleteStep(e)
                          }
                        ></StepItem>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <div
        className="flex"
        style={{
          flexDirection: "row",
          justifyContent: "center",
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        {(() => {
          switch (props.state) {
            case "ACTIVE": {
              return (
                <>
                  <Button
                    style={{}}
                    options={{
                      text: "EDIT",
                      cb: props.onEdit,
                    }}
                  ></Button>
                </>
              );
            }

            case "EDITING": {
              return (
                <>
                  <Button
                    style={{}}
                    options={{
                      text: "Add Step",
                      cb: props.onSaveStep,
                      disabled: props.steps && (props.steps.length >= 4 || props.steps.some(step => step.day === -1)) ? true : false,
                    }}
                  ></Button>
                </>
              );
            }

            case "FINISHED": {
              return (
                <>
                  <Button
                    style={{}}
                    options={{
                      text: "Run Again",
                      cb: props.onRunAgain,
                    }}
                  ></Button>
                </>
              );
            }

            case "DRAFT": {
              return (
                <>
                  <Button
                    style={{}}
                    options={{
                      text: "Add Step",
                      cb: props.onSaveStep,
                      disabled: props.steps && (props.steps.length >= 4 || props.steps.some(step => step.day === -1)) ? true : false,
                    }}
                  ></Button>

                  <Button
                    options={{
                      text: "Save",
                      cb: () => {
                        if (isZeroTimeStep) {
                          const index = props.steps.findIndex(step => step.day === 0 && step.hour === 0 && step.minutes === 0)
                          props.onSelectStepIndex && props.onSelectStepIndex(index)
                          return
                        }
                        props.onOpenSaveProgram && props.onOpenSaveProgram()
                      },
                    }}
                    style={{
                      marginLeft: 20,
                      opacity: isZeroTimeStep ? 0.5 : 1
                    }}
                  ></Button>
                </>
              );
            }
          }
        })()}
      </div>
    </div>
  );
};
